"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressDataToForm = exports.addressFormToData = void 0;
const addressFormToData = (addressForm, regions) => {
    return {
        id: addressForm.addressId,
        addressBookNickname: addressForm.addressBookNickname,
        firstName: addressForm.firstName,
        lastName: addressForm.lastName,
        line1: addressForm.addressBookLine1,
        line2: addressForm.addressBookLine2,
        town: addressForm.addressBookCity,
        region: regions.find((region) => region.isocodeShort === addressForm.addressBookState),
        postalCode: addressForm.addressBookZip,
        defaultAddress: addressForm.defaultAddress,
        isPoBox: addressForm.poBox === "P",
    };
};
exports.addressFormToData = addressFormToData;
const addressDataToForm = (addressData) => {
    return {
        addressId: addressData.id,
        addressBookNickname: addressData.addressBookNickname,
        firstName: addressData.firstName,
        lastName: addressData.lastName,
        addressBookLine1: addressData.line1,
        addressBookLine2: addressData.line2,
        addressBookCity: addressData.town,
        addressBookState: addressData.region.isocodeShort,
        addressBookZip: addressData.postalCode,
        defaultAddress: addressData.defaultAddress,
        poBox: addressData.isPoBox ? "P" : "",
    };
};
exports.addressDataToForm = addressDataToForm;
